<template>
  <xl-dialog v-model="visible" width="700px" modalClass="design-privacy-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
        <div class="head-title">{{$t('design.policyAndTerms') || '隐私政策以及使用条款'}}</div>
        <div class="sub-title">{{$t('design.policyAndTermsTip') || '请仔细阅读并同意声明以便继续使用，感谢您的理解与支持'}}</div>
        <div class="tabs">
            <div class="item" v-for="(item, index) in tabLists" :key="index" :class="activeTab === item.name ? 'item-active' : ''">{{item.label}}</div>
        </div>
    </div>
    <div class="content">
        <div v-if="activeTab === 'privacyPolicy'" v-html="props.privacyPolicyHtml"></div>
        <div v-if="activeTab === 'termsofuse'" v-html="props.termsOfUseHtml"></div>
    </div>
    <template #footer>
      <div class="footer" :class="{ isUpdate }">
        <xl-button size="large" @click="onDoNot">{{$t('design.disagree') || '不同意'}}</xl-button>
        <xl-button size="large" v-show="activeTab === 'privacyPolicy'" type="primary" :disabled="submitDisNum !== 0" :loading="loading" @click="onNext(true)">{{ $t('design.goNext') +
          (submitDisNum !== 0 ? ` (${submitDisNum}s)` : '') }}</xl-button>
        <xl-button size="large" v-show="activeTab === 'termsofuse'" type="primary" :disabled="submitDisNum !== 0" :loading="loading" @click="onDone(true)">{{ $t('design.agreeAndContinue') +
          (submitDisNum !== 0 ? ` (${submitDisNum}s)` : '') }}</xl-button>
      </div>
    </template>
  </xl-dialog>
</template>

<script setup>
// 隐藏政策服务条款
import { XlDialog, XlButton, XlTabs, XlMessageBox } from "@shining3d/ui-components";
import { ref, onMounted, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import router from '@/router';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import serviceTermsApi from "../api/serviceTerms"
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import _get from 'lodash/get';

const props = defineProps({
    privacyPolicyHtml: {
        type: String
    },
    termsOfUseVersion: {
        type: String
    },
    privacyVersion: {
        type: Number
    },
    termsOfUseHtml: {
        type: Number
    },
})
const { $t } = useLang("@shining3d/xl-design-order");
const $store = useStore();
// 机构id
// const institutionId = _get( $store, 'state.factorySelect.id', '' );
const tabLists = [
    {
        name: 'privacyPolicy',
        label: $t('design.serviceTerms.privacyPolicy') || '隐私政策'
    },
    {
        name: 'termsofuse',
        label: $t('design.serviceTerm') || '服务条款',
    }
];

const visible = ref(false);
const loading = ref(false);
const submitDisNum = ref(3);
const activeTab = ref('privacyPolicy');
let timer = null
const startDisabled = () => {
  startDisClear();
  timer = setTimeout(() => {
    submitDisNum.value = submitDisNum.value - 1
    if (submitDisNum.value > 0) {
      startDisabled();
    }
  }, 1000)
}
const startDisClear = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
};
const needAgreed = ref(false);
onMounted(() => {
    startDisabled();
});

const onDoNot = () => {
    visible.value = false;
    XlMessageBox({
        title: $t('design.reminder') || '温馨提示',
        message: $t('design.reminderMessage') || "由于您暂未同意隐私政策以及使用条款，不能设计服务功能",
        type: 'info',
        customClass: 'privacy-message-box',
    }).then(() => {
        router.push({
            path: '/u/cases'
        });
        // if ( window.history.length < 1 ) {
        //     // 跳转订单页面
        //     router.push({
        //         path: '/u/cases'
        //     });
        // } else {    
        //     router.go(-1);
        // }
    }, () => {
        router.push({
            path: '/u/cases'
        });
    });
};

const onNext = () => {
    activeTab.value = 'termsofuse';
    nextTick(() => {
        submitDisNum.value = 3;
        startDisabled();
    });
};
const emit = defineEmits(['agreeAndContinue']);
const onDone = () => {
    serviceTermsApi.updateComplianceVersion({
        associatedSystem: 'dentalx',
        contents: [
            {
                nameCode: 'privacy',
                version: props.privacyVersion
            },
            {
                nameCode: 'termsOfUse',
                version: props.termsOfUseVersion
            }
        ]
    }).then(res => {
        if( res && res.status === 'success'){
            sessionStorage.setItem( 'noNeedAgreed', true );	
	        emit( 'agreeAndContinue');
            // 同意并继续 若未绑卡则提示绑定信用卡
            // if(!$getLocalStorage('hasDefaultCard')){
            //     XlMessageBox({
            //         title: $t('design.reminder') || '温馨提示',
            //         message: $t('design.case.addCardMessage') || "您尚未绑定信用卡，请至少绑定一张卡后在新建案例",
            //         cancelButtonText: $t( 'design.cancel' ),
            //         confirmButtonText: $t( 'design.confirm' )
            //     }).then(() => {
            //         console.log( institutionId, 'institutionId======')
            //         //跳转机构设置-支付设置
            //         router.push({name: 'institutionSetting', params: { id: institutionId, target: 'payment', showAddCard: true }});
            //     })
            // }
        }
    })
    visible.value = false;
};
const open = () => {
    visible.value = true;
}
defineExpose({open, needAgreed})
</script>

<style lang="scss">
.design-privacy-dialog {
    .el-overlay-dialog {
        overflow: hidden;
    }
    .xl-dialog {
        height: calc(100vh - 96px) !important;
        box-sizing: border-box !important;
        overflow: hidden;
        margin-top: 48px;
        margin-bottom: 48px;
        display: flex;
        flex-direction: column;
        .el-dialog__header {
            display: none !important;
        }
        .el-dialog__headerbtn {
            display: none !important;
        }
        .el-dialog__body {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;

        }
        .xl-dialog__footer {
            border-top: none;
            padding: 24px 0px !important;
            display: flex;
            justify-content: center;
            align-content: center;
            .xl-button {
                min-width: 156px;
                box-sizing: border-box;
            }
        }
    }
    .head {
        height: 140px;
        background: url('../assets/image/privacyUpdateBg.png');
        background-size: contain;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding-top: 32px;
        padding-left: 24px;
        padding-right: 24px;

        .head-title {
            font-size: 22px;
            line-height: 30px;
            color: #42526E;
            font-weight: bold;
            margin-bottom: 4px;
        }
        .sub-title {
            font-size: 14px;
            line-height: 22px;
            color: #42526E;
            opacity: 0.56;
            margin-bottom: 4px;
        }
        .tabs {
            height: 48px;
            line-height: 48px;
            .item {
                display: inline-block;
                margin-right: 24px;
                font-size: 14px;
                font-weight: 500;
                font-family: aliFontT65,aliFontO65;
                color: var(--oem-color-n9);
            }
            .item-active {
                color: var(--oem-color-b4);
                border-bottom: 2px solid var(--oem-color-b4);
            }
        }
    }
    .content {
        flex: 1;
        overflow-y: auto;
        margin: 16px 24px 0 24px;
        border-radius: 6px;
        background: #F7F8FA;
        padding: 12px 12px 0px 12px;
    }
}
.privacy-message-box {
    .el-button{
        display: none;
    }
    .el-button--primary {
        display: block;
    }
}
</style>